import React from "react";

export const StuckMessage = () => {
  return (
    <div className="cw-text-destructive cw-text-[12px]">
      <span>No overlap between attendees’ meeting hours.</span>
    </div>
  );
};
